import { InternalServerErrorException } from '../../../common/exceptions/exceptions';
import { LogManager } from '../../../common/port/log/log.manager.port';
import { GetSelfCalendarScoreApplicationService } from '../../../core/application/services/scores/get-self-calendar-score.application-service';
import { SelfCalendarScoreAggregateRoot } from '../../../core/domain/aggregates/scores/self-calendar-score.aggregate-root';
import { GetSelfAllScoresRequestDto } from '../../dtos/scores/self-get-all-scores.request.dto';

export class GetSelfCalendarScoreQuery {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly service: GetSelfCalendarScoreApplicationService
  ) {}
  async execute(
    props: GetSelfAllScoresRequestDto
  ): Promise<SelfCalendarScoreAggregateRoot> {
    try {
      return await this.service.execute(props);
    } catch (error) {
      throw new InternalServerErrorException(error);
    }
  }
}
